// extracted by mini-css-extract-plugin
export default {"container":"Section08_container__vib8K","secBox":"Section08_secBox__VYBYy","secTitle":"Section08_secTitle__mRZzh","secImg":"Section08_secImg__E8ZGS"};